import Select from './Select';
export default Select;
//# sourceMappingURL=index.js.map